import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdateExpertPlanRequest } from "@shopexperts/legacy-api";
import { describeBillingApiError } from "@/app/composables/expert-billing/billingOptionForm";

interface UpdateExpertPlanInput {
  planId: number;
  data: UpdateExpertPlanRequest;
}

export function useUpdateExpertPlan() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationKey: ["admin", "expert-plans", "update"],
    mutationFn: ({ planId, data }: UpdateExpertPlanInput) => {
      return api.admin.expertSubscriptions.updatePlan({
        params: { plan: planId },
        body: data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-plans"] });
      toaster.create({
        title: "Plan updated",
        type: "success",
      });
    },
    onError: (err: Error) => {
      toaster.create({
        title: "Failed to update plan",
        description: describeBillingApiError(err),
        type: "error",
      });
      console.error("[useUpdateExpertPlan] Error:", err);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useUpdateExpertPlan;
